import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `@@pearsonvue.rpc`,
    services: {
        quiz: {
            parameters: []
        },
        info: {
            parameters: []
        },
        start_quiz: {
            parameters: []
        },
        continue_quiz: {
            parameters: []
        },
        restart_quiz: {
            parameters: []
        },
        finish_quiz: {
            parameters: []
        },
        recommended_reading: {
            parameters: []
        },
        reportlines: {
            parameters: [
                {
                    name: 'select',
                    type: 'object',
                    optional: true
                }
            ]
        },
        update_results: {
            parameters: [
                {
                    name: 'results',
                    type: 'array',
                    optional: false
                }
            ]
        },
        get_questions: {
            parameters: [
                {
                    name: 'qrlocator',
                    type: 'object',
                    optional: true
                },
                {
                    name: 'select',
                    type: 'object',
                    optional: true
                }
            ]
        }
    }
});
export default svc;
